import React from 'react';
import PolicyNoticeBanner from './common/PolicyNoticeBanner';

function PatientTerms() {
    return (
        <div style={S.body}>
            <div style={S.container}>
                {/* 구 환자앱 종료 고지 — config/policyNotices 문서 없으면 미표시 */}
                <PolicyNoticeBanner />
                {/* 📜 종료된 서비스 고정 표시 (2026-10-11 계획_케어앱_예약대기 W5·법무 P2-1, B7 (가)) — 이 문서의 예약 조항이 덴클 케어 약관과 섞여 읽히지 않게.
                    종료일은 이미 공개된 종료 고지(PatientAppLanding SHUTDOWN_FALLBACK '2026년 9월 14일')와 맞춘다. config 와 무관하게 항상 보인다 */}
                <div role="note" style={{ background: '#fff7ed', border: '1px solid #fed7aa', color: '#9a3412', borderRadius: 10, padding: '12px 14px', fontSize: 14, lineHeight: 1.6, marginBottom: 16 }}>
                    <b>{'이 문서는 2026년 9월 14일 종료된 서비스(구 덴탈클러스터 환자앱)의 문서입니다.'}</b><br />
                    {'이 문서의 내용은 지금 제공하는 서비스에 적용되지 않습니다. 지금 제공하는 덴클 케어 앱에는 '}<a href="/care/terms" style={{ color: '#9a3412', fontWeight: 700 }}>{'덴클 케어 이용약관'}</a>{'이 적용됩니다.'}
                </div>
                <div style={S.header}>
                    <h1 style={S.title}>환자 회원 이용약관</h1>
                    <p style={S.meta}>버전 v1.0 · 시행일 2026-05-01</p>
                </div>

                <section style={S.section}>
                    <h2 style={S.h2}>제1조 (목적)</h2>
                    <p style={S.p}>
                        본 약관은 주식회사 덴탈클러스터(이하 "회사")가 제공하는 환자용 모바일 애플리케이션 및 웹 서비스(이하 "서비스")의 이용과 관련하여
                        회사와 회원 간의 권리·의무·책임 사항을 규정함을 목적으로 합니다.
                    </p>

                    <h2 style={S.h2}>제2조 (서비스의 정의 및 한계)</h2>
                    <p style={S.p}>
                        ① 본 서비스는 의료기관 정보 검색, 진료 예약 정보 전달, 환자 본인의 의료 자료 보관, 검진·치료 권장 정보 제공을 목적으로 합니다.<br />
                        ② 회사는 의료행위를 하지 않으며, 환자와 의료기관 간의 진료 관련 사항(진단·치료·비용 등)에 대해 어떠한 보장이나 추천도 하지 않습니다.<br />
                        ③ 회사는 환자를 특정 의료기관에 알선·유인하지 않으며, 의료기관의 진료비·시술비와 관련된 어떠한 수수료도 받지 않습니다.<br />
                        ④ 본 서비스에서 제공되는 검진·치료 권장 정보는 일반적인 의료 정보 제공을 목적으로 하며, 의료적 진단·처방을 대체하지 않습니다.
                    </p>

                    <h2 style={S.h2}>제3조 (회원가입)</h2>
                    <p style={S.p}>
                        ① 만 14세 이상의 자연인은 본 약관에 동의함으로써 회원가입을 신청할 수 있습니다.<br />
                        ② 회사는 다음 각 호에 해당하는 경우 회원가입을 거절하거나 취소할 수 있습니다.
                        <br />- 타인의 명의를 도용한 경우
                        <br />- 회원가입 신청 시 허위 정보를 기재한 경우
                        <br />- 만 14세 미만이거나 법정대리인의 동의를 얻지 않은 경우
                    </p>

                    <h2 style={S.h2}>제4조 (회원의 의무)</h2>
                    <p style={S.p}>
                        ① 회원은 가입 시 정확한 정보를 제공해야 하며, 변경 시 즉시 갱신해야 합니다.<br />
                        ② 회원은 본인의 계정 정보를 안전하게 관리해야 하며, 타인에게 양도·대여할 수 없습니다.<br />
                        ③ 회원은 다른 회원·의료기관·회사에 피해를 주는 행위를 해서는 안 됩니다.
                    </p>

                    <h2 style={S.h2}>제5조 (예약 서비스)</h2>
                    <p style={S.p}>
                        ① 본 서비스의 예약 기능은 회원이 의료기관에 예약 의사를 전달하는 정보 전달 도구입니다.<br />
                        ② 예약의 최종 확정·거절 권한은 의료기관에 있으며, 회사는 예약 결과에 대해 보장하지 않습니다.<br />
                        ③ 예약 가능 의료기관은 본 서비스 가입 의료기관에 한정될 수 있습니다.<br />
                        ④ 예약 시 입력된 정보는 해당 의료기관에만 전달되며, 회사는 진료비·시술비 정산에 일절 개입하지 않습니다.
                    </p>

                    <h2 style={S.h2}>제6조 (의료 자료 보관)</h2>
                    <p style={S.p}>
                        ① 회원이 업로드하는 영수증·X-ray·처방전 등은 회원 본인의 개인 자료이며, 회사는 이를 회원의 동의 없이 제3자에게 제공하지 않습니다.<br />
                        ② 회원이 업로드한 자료는 의료법상 의료기록이 아니며, 본인의 참고·관리 목적으로 사용됩니다.<br />
                        ③ 회사는 회원의 자료를 안전하게 보관하기 위해 합리적 보안 조치를 취합니다.
                    </p>

                    <h2 style={S.h2}>제7조 (검진·치료 권장 정보)</h2>
                    <p style={S.p}>
                        ① 회사는 보건복지부·심평원 등 공공기관 데이터를 기반으로 일반 의료 정보를 제공합니다.<br />
                        ② 권장 정보는 의료적 진단·처방을 대체하지 않으며, 정확한 진료는 의료기관 상담을 통해 받아야 합니다.<br />
                        ③ 회사는 권장 정보의 적용 결과에 대해 책임을 지지 않습니다.
                    </p>

                    <h2 style={S.h2}>제8조 (회사의 의무)</h2>
                    <p style={S.p}>
                        ① 회사는 안정적인 서비스 제공을 위해 노력하며, 시스템 점검·장애 시 사전·사후 안내합니다.<br />
                        ② 회사는 회원의 개인정보를 적법하게 처리하며, 개인정보처리방침에 따라 보호합니다.
                    </p>

                    <h2 style={S.h2}>제9조 (서비스 이용 제한)</h2>
                    <p style={S.p}>
                        회사는 다음 각 호의 경우 회원의 서비스 이용을 제한할 수 있습니다.
                        <br />- 본 약관 또는 관련 법령을 위반한 경우
                        <br />- 타인의 명의 도용·허위 정보 제공
                        <br />- 의료기관·다른 회원에게 위해를 가한 경우
                        <br />- 정당한 사유 없이 반복적으로 예약 후 미방문(노쇼)한 경우
                    </p>

                    <h2 style={S.h2}>제10조 (탈퇴 및 계정 삭제)</h2>
                    <p style={S.p}>
                        ① 회원은 언제든지 서비스 내 설정에서 탈퇴할 수 있습니다.<br />
                        ② 탈퇴 시 회원의 정보는 관련 법령에 따라 일정 기간 보관 후 파기됩니다.
                    </p>

                    <h2 style={S.h2}>제11조 (책임의 한계)</h2>
                    <p style={S.p}>
                        ① 회사는 천재지변, 정전, 통신 두절 등 불가항력으로 인한 서비스 중단에 대해 책임을 지지 않습니다.<br />
                        ② 회원이 의료기관에서 받은 진료의 결과·만족도에 대해 회사는 책임을 지지 않습니다.<br />
                        ③ 회원이 업로드한 자료의 진위·정확성에 대한 책임은 회원에게 있습니다.
                    </p>

                    <h2 style={S.h2}>제12조 (분쟁 해결)</h2>
                    <p style={S.p}>
                        ① 본 약관은 대한민국 법령에 따라 해석됩니다.<br />
                        ② 서비스 이용과 관련하여 분쟁이 발생할 경우 양 당사자는 우선 협의로 해결하며, 협의가 이루어지지 않을 경우 회사 본점 소재지 관할 법원을 합의 관할로 합니다.
                    </p>

                    <h2 style={S.h2}>제13조 (약관의 변경)</h2>
                    <p style={S.p}>
                        ① 회사는 관련 법령을 위반하지 않는 범위에서 본 약관을 개정할 수 있습니다.<br />
                        ② 약관 개정 시 적용 14일 전(중요 사항은 30일 전)에 공지합니다.
                    </p>

                    <p style={S.lastUpdate}>
                        시행일: 2026년 5월 1일<br />
                        주식회사 덴탈클러스터
                    </p>
                </section>
            </div>
        </div>
    );
}

const S = {
    body: { backgroundColor: '#f8fafc', minHeight: '100vh', fontFamily: "'Apple SD Gothic Neo', 'Malgun Gothic', sans-serif", color: '#0f172a', padding: '40px 20px' },
    container: { maxWidth: 760, margin: '0 auto', backgroundColor: '#fff', padding: '40px', borderRadius: 14, border: '1px solid #e2e8f0' },
    header: { textAlign: 'center', marginBottom: 32, paddingBottom: 20, borderBottom: '2px solid #0ea5e9' },
    title: { fontSize: 26, fontWeight: 900, margin: '0 0 6px' },
    meta: { fontSize: 12, color: '#64748b' },
    section: { lineHeight: 1.8 },
    h2: { fontSize: 16, fontWeight: 800, marginTop: 28, marginBottom: 8 },
    p: { fontSize: 13.5, color: '#334155', whiteSpace: 'pre-line', marginBottom: 6 },
    lastUpdate: { textAlign: 'right', marginTop: 40, fontSize: 12, color: '#64748b', borderTop: '1px solid #e2e8f0', paddingTop: 16 },
};

export default PatientTerms;
